module.exports = __webpack_public_path__ + "media/nav/artkiveLogo-7a68f2ae.svg";